<template>
  <div class="contact">
    <SiteHeader v-if="!currentUserProfile"/>
    <HeroBanner :title="'Contact'" :subtitle="'Get in touch with us'"/>
    <section>
      <div class="form-wrap" v-if="!sent">
        <FormulateForm
          ref="contactForm"
          v-model="formValues"
          :schema="contactFormSchema"
          @submit="submitHandler"
        />
        <button @click="onSubmit" :disabled="sending" v-html="sending ? 'Sending...' : 'Submit'"/>
      </div>
      <div class="form-wrap" v-else>
        <h1>Thank You!</h1>
        <p>We'll get back to you as soon as we can</p>
      </div>
    </section>
  </div>
</template>

<script>
import * as fb from '@/library/firebase'
import { mapGetters, mapState } from 'vuex'
import contactFormSchema from '@/forms/contactFormSchema'
import HeroBanner from '@/components/HeroBanner'
import SiteHeader from '@/components/SiteHeader'

export default {
  name: 'Contact',
  computed: {
    ...mapState([
      'adminEmail'
    ]),
    ...mapGetters([
      'currentUserProfile'
    ]),
  },
  data(){
    return{
      sending: false,
      sent: false,
      formValues: {},
      contactFormSchema
    }
  },
  components: {
    SiteHeader,
    HeroBanner
  },
  methods: {
    submitHandler(data) {
      const sendEmail = fb.funcs.httpsCallable('sendEmail')
      const to = this.adminEmail
      const subject = 'Contact submission'
      const { email, firstName, lastName, message } = data
      const messageBody = `${firstName} ${lastName} (${email}) says: ${message}`
      sendEmail({ to, subject, message: messageBody }).then(result => {
        // Read result of the Cloud Function.
        // var sanitizedMessage = result.data.text
        // console.log(sanitizedMessage); // eslint-disable-line
        console.log(result); /* eslint-disable-line */
        this.sent = true
        this.sending = false
      }).catch(error => {
        this.$notify({
          duration: 10000,
          group: 'default',
          title: 'Error',
          type: 'error',
          text: error
        })
        this.sending = false
      })
    },
    onSubmit(){
      this.$refs.contactForm.formSubmitted()
      this.sending = true
    }
  }
}
</script>

<style scoped lang="scss">
img.preview {
  width: 200px;
}
.form-wrap {
  padding: 4rem;
  flex: 1;
}
.col2 img {
  max-width: 100%;
}
.input-wrap {
  padding: 2rem;
  border: solid 1px #ccc;
}
.upload-btn-wrap {
  padding: 2rem 0;
  button {
    @include btn-primary;
  }
}
button {
  @include btn;
}
/deep/ {
  @include formStyles;
}
</style>